import Vue from "vue";
import Router from "vue-router";

import Home from "@/pages/Home";
import SpeedTest from "@/pages/SpeedTest";
import SinavSpeedTest from "@/pages/SinavSpeedTest";
import Tests from "@/pages/Tests";
import TestDetail from "@/pages/TestDetail";
import Exercises from "@/pages/Exercises";
import ExerciseDetail from "@/pages/ExerciseDetail";
import Login from "@/pages/Login";
import Courses from "@/pages/Courses";
import CourseDetail from "@/pages/CourseDetail";
import CourseTest from "@/pages/CourseTest";
import RepeatCourse from "@/pages/RepeatCourse";
import ForKids from "@/pages/ForKids";
import Tekerleme from "@/pages/Tekerleme";
import Siir from "@/pages/Siir";
import ExercisesChild from "@/pages/ExercisesChild";
import ConfigTest from "@/pages/ConfigTest";
import StepTest from "@/pages/StepTest";
import FeedBackTest from "@/pages/FeedBackTest";

Vue.use(Router);

export default new Router({
  linkActiveClass: "is-active",
  routes: [
    {
      name: "Home",
      path: "/",
      component: Home
    },
    {
      name: "FeedBackTest",
      path: "/feedback-test/:id",
      component: FeedBackTest
    },
    {
      name: "SpeedTest",
      path: "/speed-test",
      component: SpeedTest
    },
    {
      name: "SinavSpeedTest",
      path: "/sinav-speed-test",
      component: SinavSpeedTest
    },
    {
      name: "Login",
      path: "/login",
      component: Login
    },
    {
      name: "Tests",
      path: "/tests",
      component: Tests
    },
    {
      name: "TestDetail",
      path: "/tests/:test_id/:part_id",
      component: TestDetail
    },
    {
      name: "Exercises",
      path: "/exercises",
      component: Exercises
    },
    {
      name: "ExerciseDetail",
      path: "/exercises/:type",
      component: ExerciseDetail
    },
    {
      name: "Courses",
      path: "/courses",
      component: Courses
    },
    {
      name: "CourseDetail",
      path: "/courses/:course_id",
      component: CourseDetail
    },
    {
      name: "CourseTest",
      path: "/test/:course_id/:day/:step",
      component: CourseTest
    },
    {
      name: "RepeatCourse",
      path: "/courses/repeat/:course_id/:step",
      component: RepeatCourse
    },
    {
      name: "ForKids",
      path: "/for-kids",
      component: ForKids
    },
    {
      name: "Tekerleme",
      path: "/tekerleme",
      component: Tekerleme
    },
    {
      name: "Siir",
      path: "/siir",
      component: Siir
    },
    {
      name: "ExercisesChild",
      path: "/exercises-child",
      component: ExercisesChild
    },
    {
      name: "ConfigTest",
      path: "/config-test",
      component: ConfigTest
    },
    {
      name: "StepTest",
      path: "/step-test",
      component: StepTest
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js